import { SpinnerService } from "@app/services/spinner.service";
import { Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

/**
 * Created by req89873 on 10/13/16.
 * This page lobbies an embedded iFrame to achieve what it needs to. The iframe's source can be found PAY/digitalpayments
 */
@Component({
    selector: 'app-credit-card-edit',
    template: require('./cardDetails.html')
})
export class EditCardDetailsComponent implements OnInit {
    paymentMethodId: number

    constructor(@Inject(SpinnerService) private spinnerService: SpinnerService,
                @Inject(Router) private router: Router,
                @Inject(ActivatedRoute) private route: ActivatedRoute) {}

    ngOnInit() {
        this.paymentMethodId = Number(this.route.snapshot.params.paymentMethodId)

        this.spinnerService.showSpinner();
    }

    onReturn() {
        this.router.navigateByUrl('/wallet/viewcarddetails/' + this.paymentMethodId,
            { state: { paymentMethodId: this.paymentMethodId } });
    }

    onGoTo() {
        this.router.navigateByUrl('/wallet')
    }
}

